import { UserData } from './user-data';

export class SaveUserRequest {
  constructor(
    public data: UserData,
    public password: string
  ) {}
}
